module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-16 at 12.11.59 PM.b5b887c9.jpeg";